exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".botao_senha[data-v-be5432a6] {\n  cursor: pointer;\n  font-size: 18px;\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n.login-error-sheet[data-v-be5432a6] {\n  font-size: 14px;\n  line-height: 18px;\n  color: #ee1d23 !important;\n}\n[data-v-be5432a6] .v-application--wrap {\n  min-height: -moz-fit-content;\n  min-height: fit-content;\n}", ""]);

// exports
